import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { IpValidationUtils  } from '../../../../../../common/validations/ip-validation-utils';
let $ = require('jquery');
import { AppState } from '../../../../../app.service';
import { NgForm } from '@angular/forms';
import { Service } from '../org-vdc-wizard.service';
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';
import { ArrayUtils } from '../../../../../../common/utils/array-utils';
const _ = require('lodash');

@Component({
  selector: 'edit-vdc-dialog',
  styles: [require('../org-vdc.wizard.scss')],
  template: require('./edit-vdc.html'),
   providers: [
    TranslateService, Service
  ]
})

export class EditVdcDialog {
    @Input() orgVdcId: string = '';
    @Input() isDialogOpen: boolean = false;
    @Output('onClose') selfClose = new EventEmitter();

    private showGuaranteeFields: boolean = false;
    private editData: any;
    private subscribeHandler;
    private isValid: boolean = true;
    private crudResult: any;
    private loading: boolean = false;
    private isPageLoading: boolean = false;
    private isIpRangeValid: false;
    private pVDCList: any;
    private pVDCSelected: any;
    private isGetEditDataCompleted: boolean = false;
    private pVDCDisplay: any;
    private isPVDCLoaded: boolean = false;
    private decimalPattern = /^[0-9]+(\.[0-9]{1,2})?$/;
    private dataModel = {
      orgName: '',
      selectedOrgId: '',
      name: '',
      description: '',
      allocModel: '',
      cpu: 0,
      memory: 0,
      cpuGuarantee: 0,
      memoryGuarantee: 0,
      storage: 0
    };

    constructor(public service: Service, private translate: TranslateService, private alert: VcaAlertsService) {
        translate.use(GlobalVariables.LOCALE);
    }

    resetForm() {
    }

    ngOnChanges(changes) {
        if (this.orgVdcId && this.isDialogOpen) {
            this.getEditData();
            this.getPVdcs();
        }
    }

    getEditData() {
        this.isPageLoading = true;
        this.isGetEditDataCompleted = false;
        this.subscribeHandler = this.service.getVirtualdc(this.orgVdcId)
            .subscribe(
            editData => {
                this.editData = editData;
                this.isGetEditDataCompleted = true;
                this.setDataModel();
                this.filterPVDC();
                this.isPageLoading = false;
            },
            error => {
                this.service.logError(error, 'get Edit data error')
            },
            () => {
                this.service.logOperationCompleted('get Edit data Completed')
            }
        );
    }

    getPVdcs() {
        this.subscribeHandler = this.service.getPVdcs()
        .subscribe(
            result => {
            this.pVDCList = result;
            this.filterPVDC();
            },
            error => this.service.logError(error, 'get SDDC Pool'),
            () => this.service.logOperationCompleted('get SDDC Pool completed')
        );
    }

    filterPVDC() {
        if (!this.pVDCList || !this.editData) {
            return;
        }
        let objectId = (ArrayUtils.isPropertyExist(this.editData, 'providerVDC.vcd.objectId')) ? this.editData.providerVDC.vcd.objectId : '';
        this.pVDCSelected = _.find(this.pVDCList, 'objectId', objectId);
        this.processPVDC();
    }

    processPVDC() {
        if (!this.pVDCSelected) {
            return;
        }

        let data = this.pVDCSelected;
        let storageTotal = 0;
        let storageUnits = [];
        for (let j = 0; j < data.storageProfiles.length; j++) {
            let sp = data.storageProfiles[j];
            if (sp.units && sp.capacityTotal) {
            storageTotal +=  (sp.units === "MB") ? sp.capacityTotal / 1024 : sp.capacityTotal;
            }
        }

        let cpu = (data.cpu && data.cpu.total) ? data.cpu.total : '-';
        if (cpu !== '-' && data.cpu.units === "MHz") {
                cpu /= 1024;
        }

        let memory = (data.memory && data.memory.total) ? data.memory.total : '-';
        if (memory !== '-' && data.memory.units === "MB") {
                memory /= 1024;
        }

        this.pVDCDisplay = {
            name: (data.name) ? data.name : '-' ,
            cpu: (cpu !== '-') ? cpu.toFixed(2) : '-',
            memory: (memory !== '-') ? memory.toFixed(2) : '-',
            storageTotal: storageTotal.toFixed(2),
            iopsEnabled: (data.iopsEnabled) ? data.iopsEnabled : 'false',
            isReady: true
        }
        this.isPVDCLoaded = true;
    }

    setDataModel() {
        if (!this.editData) {
            return;
        }

        let data = this.editData;
        this.dataModel.orgName = data.orgName;
        this.dataModel.name = data.name;
        this.dataModel.description = (data.description) ? data.description : '';

        this.dataModel.allocModel = data.allocationModel;
        let cpu, memory, storage;
        if (data.computeCapacity) {
            let compCap = data.computeCapacity;

            if (this.dataModel.allocModel === 'RESERVATIONPOOL') {
                cpu = (compCap.cpu) ? compCap.cpu.limit / 1000 : 0;
                this.dataModel.cpu = parseFloat(cpu.toFixed(2));

                memory = (compCap.memory) ? compCap.memory.limit / 1024 : 0;
                this.dataModel.memory = parseFloat(memory.toFixed(2));
            } else {
                cpu = (compCap.cpu) ? compCap.cpu.allocated / 1000 : 0;
                this.dataModel.cpu = parseFloat(cpu.toFixed(2));

                memory = (compCap.memory) ? compCap.memory.allocated / 1024 : 0;
                this.dataModel.memory = parseFloat(memory.toFixed(2));
                this.dataModel.cpuGuarantee = (data.resourceGuaranteedCpu) ? data.resourceGuaranteedCpu * 100 : 0;
                this.dataModel.memoryGuarantee = (data.resourceGuaranteedMemory) ? this.editData.resourceGuaranteedMemory * 100 : 0;
                this.showGuaranteeFields = true;
            }
        }
        storage = this.editData.storageCapacity.reserved / 1024;
        this.dataModel.storage = parseFloat(storage.toFixed(2));
    }

    postData() {
        let data = this.dataModel;
        let vdcSpec;
        let cpuGuarantee: number = 0;
        let memoryGuarantee: number = 0;
        if (data.allocModel === 'ALLOCATIONPOOL') {
            cpuGuarantee = Number(data.cpuGuarantee);
            cpuGuarantee = (cpuGuarantee > 0 ) ? cpuGuarantee / 100 : cpuGuarantee;
            memoryGuarantee = Number(data.memoryGuarantee);
            memoryGuarantee = (memoryGuarantee > 0) ? memoryGuarantee / 100 : memoryGuarantee;
        }

        vdcSpec = {
            name : data.name,
            description: data.description,
            allocationModel: data.allocModel,
            cpuCapacity: {
                allocated: (data.cpu) ? Number(data.cpu) * 1000 : 0,
                limit: (data.cpu) ? Number(data.cpu) * 1000 : 0,
                unit: 'MHz'
            },
            memoryCapacity: {
                allocated: (data.memory) ? Number(data.memory) * 1024 : 0,
                limit: (data.memory) ? Number(data.memory) * 1024 : 0,
                unit: 'MB'
            },
            resourceGuaranteedCpu: cpuGuarantee,
            resourceGuaranteedMemory: memoryGuarantee
        };

        this.loading = true;
        this.isValid = false;
        this.subscribeHandler = this.service.updateOrgVDC(vdcSpec, this.editData['objectId'])
        .subscribe(
            (crudResult: any) => {
                    this.isValid = true;
                    this.loading = false;
                if (crudResult && crudResult.error) {
                    this.alert.danger([crudResult.errorMessage], 'edit-vdc-dialog');
                } else {
                    this.crudResult = crudResult;
                    this.closeSelf();
                }
            },
            error => {
                this.isValid = true;
                this.loading = false;
                this.alert.danger(['Operation Failed. Please try again', error], 'edit-sp-dialog');
            },
            () => {
                this.service.logOperationCompleted('Edit OrgVdc Completed')
            }
        );
    }

    onSubmitButtonClicked(f: NgForm) {
        this.postData();
    }

    onCancelButtonClicked() {
        this.closeSelf();
    }

    checkFormValid(value, isDecimalCheck: boolean = false) {
        if (isDecimalCheck && (!value || !this.decimalPattern.test(value))) {
            this.isValid = false;
            return;
        }

        let data = this.dataModel;
        let check1: boolean = false;
        let check2: boolean = false;
        check1 = data.cpu >= 0 && data.memory >= 0 && data.name !== '';
        if (data.allocModel === 'RESERVATIONPOOL') {
            this.isValid = check1;
            return;
        } else {
            check2 = (data.cpuGuarantee >= 0  && data.cpuGuarantee <=100)  && (data.memoryGuarantee >= 20 && data.memoryGuarantee <= 100);
            this.isValid = check1 && check2;
            return;
        }
    }

    ngOnDestroy() {
        if (this.subscribeHandler) {
            this.subscribeHandler.unsubscribe();
        }
    }

    closeSelf() {
        if (this.selfClose) {
        this.selfClose.emit({
            value: 'close'
        });
        }
    }

    getAllocModel() {
        if (this.dataModel.allocModel === 'RESERVATIONPOOL') {
            return this.translate.instant('createOrgVdc.allocModel.RESERVATIONPOOL');
        } else if (this.dataModel.allocModel === 'ALLOCATIONPOOL') {
            return this.translate.instant('createOrgVdc.allocModel.ALLOCATIONPOOL');
        } else if (this.dataModel.allocModel === 'PAYASYOUGO') {
            return this.translate.instant('createOrgVdc.allocModel.PAYASYOUGO');
        }
        return '-';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/dialog/edit-vdc-component.ts